import type { ReactNode } from "react";

/**
 * The top of one admin page: its title, one line on what it does, and the page's
 * primary action on the right. Lives in the admin shell's content column; the
 * shell (`pages/admin/AdminLayout.tsx`) owns the page heading and the left menu.
 */
export function AdminSectionHeader({
  title,
  titleId,
  description,
  meta,
  actions,
}: {
  readonly title: ReactNode;
  readonly titleId?: string;
  readonly description?: ReactNode;
  /** A quiet fact beside the title ("3 members · 1 open invitation"). */
  readonly meta?: ReactNode;
  readonly actions?: ReactNode;
}) {
  return (
    <header className="ad-section-head">
      <div className="ad-section-title">
        <h2 id={titleId}>{title}</h2>
        {description ? <p>{description}</p> : null}
      </div>
      {meta ? <p className="ad-section-meta">{meta}</p> : null}
      {actions ? <div className="ad-section-actions">{actions}</div> : null}
    </header>
  );
}

/** A page's loading line, inside the shell's content column. */
export function AdminSectionLoading({ label }: { readonly label: string }) {
  return (
    <p className="ad-loading" role="status">
      <span className="ad-spinner" aria-hidden="true" />
      {label}
    </p>
  );
}
